import { useContext } from "react";
import { AutocompleteInput, BooleanField, BooleanInput, CreateButton, Datagrid, FilterButton, List, ReferenceInput, sanitizeListRestProps, TextField, TextInput, TopToolbar, useListContext } from "react-admin";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";

const GuidelineTypeList = (props) => {

    const context = useContext(AppContext)

    const userFilters = [
        <TextInput source='name' label='Nome' alwaysOn />,
    ]

    const adminFilters = [
        <BooleanInput label='Público' source='public' defaultValue={true} />
    ]

    const institutionBranchFilter = (
        <ReferenceInput
            label='Unidade'
            source="institution_branch"
            reference="institution-branches"
            sort={{ field: context.profile.name === ProfileEnum.SUPERADMIN ? 'institution.name' : 'name', order: 'ASC' }}
            perPage={99}
            alwaysOn
            allowEmpty={false}
            resettable
            clearAlwaysVisible={true}
        >
            <AutocompleteInput
                source="name"
                optionText={record => context.profile.name === ProfileEnum.SUPERADMIN ? `${record?.institution?.name} - ${record?.name}` : record?.name}
            />
        </ReferenceInput>
    )

    const institutionFilter = (
        <ReferenceInput
            label="Instituição"
            source="institution"
            reference="institutions"
            filterToQuery={(text) => ({ "institution.name": text })}
            sort={{ field: 'institution.name', order: 'ASC' }}
            allowEmpty={false}
            resettable
            clearAlwaysVisible={true}
        >
            <AutocompleteInput
                source="name"
                emptyText="Todas"
                fullWidth
            />
        </ReferenceInput>
    )

    const superAdmin = context.profile.name === ProfileEnum.SUPERADMIN

    if (superAdmin || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) {
        userFilters.push(institutionBranchFilter)
    }

    if (superAdmin) {
        adminFilters.push(institutionFilter)
    }

    const filters = superAdmin ? [...userFilters, ...adminFilters] : userFilters

    const CustomActions = (props) => {
        const {
            className,
            exporter,
            filters,
            maxResults,
            ...rest
        } = props;
        const {
            basePath,
        } = useListContext();
        return (
            <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
                <FilterButton />
                {context.profile.name !== ProfileEnum.GENERAL_PRINCIPAL && <CreateButton basePath={basePath} />}
            </TopToolbar>
        );
    }

    return (
        <List
            exporter={false}
            bulkActionButtons={false}
            filters={filters}
            title={'Tipos de parte'}
            sort={{ field: 'name', order: 'ASC' }}
            actions={<CustomActions />}
            {...props}
        >
            <Datagrid rowClick={'edit'}>
                <TextField source="name" label={'Nome'} />
                {context.profile.name === ProfileEnum.SUPERADMIN && <TextField source="institution_branch.institution.name" label={'Instituição'} />}
                {(context.profile.name === ProfileEnum.SUPERADMIN || context.profile.name === ProfileEnum.GENERAL_PRINCIPAL) && <TextField source="institution_branch.name" label={'Unidade'} />}
                <BooleanField source="public" label={'Pública?'} />
            </Datagrid>
        </List>
    )
}


export default GuidelineTypeList;